export default __webpack_public_path__ + "static/media/Turbo_Cruise_84_LE.2cc215ab.jpg";